module.exports = __webpack_public_path__ + "img/expect.fe99b343.png";